import AdminLayout from './layouts/Admin.vue';

import { PERMISSIONS } from '@/composables/policies/permissions'

export const adminRoutes = {
  path:'/admin',
  meta: { 
    permissions: [PERMISSIONS.admin.dashboard],
    requiresAuth: true
  },
  children: [
    {
      path: "",
      name: "admin-home",
      component: () => import("./views/admin/Home.vue"),
      meta: { title: 'Admin', layout: AdminLayout }
    },
    {
      path: "frequently-asked-questions",
      name: "admin-faq",
      meta: { 
        permissions: [
          PERMISSIONS.admin.faqs.view
        ]
      },
      children: [
        {
          path: "",
          name: "admin-faq-listing",
          component: () => import("./views/admin/faq/Listing.vue"),
          meta: { title: 'FAQ', layout: AdminLayout }
        },
        {
          path: "sections/:section_id",
          name: "admin-faq-show-section",
          component: () => import("./views/admin/faq/ShowSection.vue"),
          meta: { 
            title: 'Show Section', 
            layout: AdminLayout, 
            permissions: [
              PERMISSIONS.admin.faqs.view
            ]
          }
        },
        {
          path: ":section_id/new",
          name: "admin-faq-new-question",
          component: () => import("./views/admin/faq/NewQuestion.vue"),
          meta: { 
            title: 'New Question', 
            layout: AdminLayout, 
            permissions: [
              PERMISSIONS.admin.faqs.create
            ]
          }
        },
        {
          path: ":question_id/edit",
          name: "admin-faq-edit-question",
          component: () => import("./views/admin/faq/EditQuestion.vue"),
          meta: { 
            title: 'Edit Question', 
            layout: AdminLayout, 
            permissions: [
              PERMISSIONS.admin.faqs.update
            ]
          }
        }
      ]
    },
    {
      path: "announcements",
      name: "admin-announcements",
      meta: {
        permissions: [PERMISSIONS.admin.announcements.view]
      },
      children: [
        {
          path: "",
          name: "admin-announcements-listing",
          component: () => import("./views/admin/announcements/Listing.vue"),
          meta: { title: 'Announcements', layout: AdminLayout, permissions: [PERMISSIONS.admin.announcements.view] }
        },
        {
          path: "new",
          name: "admin-announcements-new",
          component: () => import("./views/admin/announcements/New.vue"),
          meta: { title: 'New Announcement', layout: AdminLayout, permissions: [PERMISSIONS.admin.announcements.create] }
        },
        {
          path: ":id/edit",
          name: "admin-announcements-edit",
          component: () => import("./views/admin/announcements/Update.vue"),
          meta: { title: 'Edit Announcement', layout: AdminLayout, permissions: [PERMISSIONS.admin.announcements.update] }
        }
      ],
    },
    {
      path: "email-templates",
      name: "admin-email-templates",
      meta: {
        // Backend: EmailTemplatePolicy grants each action via manage_all OR the specific permission.
        permissions: [PERMISSIONS.admin.emailTemplates.access, PERMISSIONS.admin.emailTemplates.manageAll],
        permissionMode: 'any'
      },
      children: [
        {
          path: "",
          name: "admin-email-templates-listing",
          component: () => import("./views/admin/email-templates/Listing.vue"),
          meta: { title: 'Email Templates', layout: AdminLayout, permissions: [PERMISSIONS.admin.emailTemplates.access, PERMISSIONS.admin.emailTemplates.manageAll], permissionMode: 'any' }
        },
        {
          path: "new",
          name: "admin-email-templates-new",
          component: () => import("./views/admin/email-templates/New.vue"),
          meta: { title: 'New Email Template', layout: AdminLayout, permissions: [PERMISSIONS.admin.emailTemplates.create, PERMISSIONS.admin.emailTemplates.manageAll], permissionMode: 'any' }
        },
        {
          path: ":id/edit",
          name: "admin-email-templates-edit",
          component: () => import("./views/admin/email-templates/Edit.vue"),
          meta: { title: 'Edit Email Template', layout: AdminLayout, permissions: [PERMISSIONS.admin.emailTemplates.update, PERMISSIONS.admin.emailTemplates.manageAll], permissionMode: 'any' }
        }
      ],
    },
    {
      path: "categories",
      name: "admin-categories",
      meta: {
        permissions: [PERMISSIONS.admin.categories.view]
      },
      children: [
        {
          path: "",
          name: "admin-categories-listing",
          component: () => import("./views/admin/categories/Listing.vue"),
          meta: { title: 'Categories', layout: AdminLayout, permissions: [PERMISSIONS.admin.categories.view] }
        },
        {
          path: ":id",
          name: "admin-categories-show",
          component: () => import("./views/admin/categories/Show.vue"),
          meta: { title: 'Categories', layout: AdminLayout, permissions: [PERMISSIONS.admin.categories.manageClubs] }
        },
        {
          path: "new",
          name: "admin-categories-new",
          component: () => import("./views/admin/categories/New.vue"),
          meta: { title: 'Categories', layout: AdminLayout, permissions: [PERMISSIONS.admin.categories.create] }
        }
      ],
    },
    {
      path: "contact-lists",
      name: "admin-contact-lists",
      meta: {
        permissions: [PERMISSIONS.admin.contactLists.manage]
      },
      children: [
        {
          path: "",
          name: "admin-contact-lists-listing",
          component: () => import("./views/admin/contact-lists/Listing.vue"),
          meta: { title: 'Contact Lists', layout: AdminLayout, permissions: [PERMISSIONS.admin.contactLists.manage] }
        },
        {
          path: ":id",
          name: "admin-contact-lists-show",
          component: () => import("./views/admin/contact-lists/Show.vue"),
          meta: { title: 'Contact List', layout: AdminLayout, permissions: [PERMISSIONS.admin.contactLists.manage] }
        }
      ],
    },
    {
      path: "terms",
      meta: { permissions: [PERMISSIONS.admin.terms.view] },
      name: "admin-terms",
      children: [
        {
          path: "",
          name: "admin-terms-listing",
          component: () => import("./views/admin/terms/Listing.vue"),
          meta: { title: 'Terms Listing', layout: AdminLayout }
        },
        {
          path: ":term_id",
          name: "admin-terms-show",
          component: () => import("./views/admin/terms/Show.vue"),
          redirect: { name: 'admin-terms-show-overview' },
          meta: { title: 'Terms', layout: AdminLayout, breadcrumb: { label: 'View', to: 'admin-terms-show' } },
          children: [
            {
              path: 'overview',
              name: 'admin-terms-show-overview',
              components: { adminDetail: () => import("./views/admin/terms/components/TermOverview.vue") },
              meta: { title: 'Term - Overview', layout: AdminLayout, breadcrumb: { label: 'Overview', to: 'admin-terms-show-overview' } }
            },
            {
              path: 'active-clubs',
              name: 'admin-terms-show-active-clubs',
              components: { adminDetail: () => import("./views/admin/terms/components/TermActiveClubs.vue") },
              meta: { title: 'Term - Active Clubs', layout: AdminLayout, breadcrumb: { label: 'Active Clubs', to: 'admin-terms-show-active-clubs' } }
            },
            {
              path: 'inactive-clubs',
              name: 'admin-terms-show-inactive-clubs',
              components: { adminDetail: () => import("./views/admin/terms/components/TermInactiveClubs.vue") },
              meta: { title: 'Term - Inactive Clubs', layout: AdminLayout, breadcrumb: { label: 'Inactive Clubs', to: 'admin-terms-show-inactive-clubs' } }
            },
            {
              path: 'term-acknowledgement-forms',
              name: 'admin-terms-show-term-acknowledgement-forms',
              components: { adminDetail: () => import("./views/admin/terms/components/TermAcknowledgementForms.vue") },
              meta: { title: 'Term - Term Acknowledgements', layout: AdminLayout, breadcrumb: { label: 'Term Acknowledgements', to: 'admin-terms-show-term-acknowledgement-forms' } }
            }
          ]
        }
      ]
    },
    {
      path: "organizations",
      name: "admin-organizations",
      component: () => import("./views/admin/organizations/Show.vue"),
      meta: { title: 'Organization Settings', layout: AdminLayout, permissions: [PERMISSIONS.admin.organizations.view] }
    },
    {
      path: "club-applications",
      name: "admin-club-applications",
      meta: { title: 'Club Applications', layout: AdminLayout, permissions: [PERMISSIONS.admin.clubApplications.access] },
      children: [
        {
          path: "pending",
          name: "admin-club-applications-pending",
          component: () => import("./views/admin/club-applications/Listing.vue"),
          meta: { title: 'Clubs', layout: AdminLayout },
          props: { 
            state: 'cs_approval_pending',
            title: 'Pending Club Applications'
          }
        },
        {
          path: "rejected",
          name: "admin-club-applications-rejected",
          component: () => import("./views/admin/club-applications/Listing.vue"),
          meta: { title: 'Clubs', layout: AdminLayout },
          props: { 
            state: 'rejected',
            title: 'Rejected Club Applications'
          }
        },
        {
          path: "approved",
          name: "admin-club-applications-completed",
          component: () => import("./views/admin/club-applications/Listing.vue"),
          meta: { title: 'Clubs', layout: AdminLayout },
          props: {
            state: 'completed',
            title: 'Approved Club Applications'
          }
        },
        {
          path: "changes-requested",
          name: "admin-club-applications-changes-requested",
          component: () => import("./views/admin/club-applications/Listing.vue"),
          meta: { title: 'Clubs', layout: AdminLayout },
          props: {
            state: 'changes_requested',
            title: 'Club Applications - Changes Requested'
          }
        },
      ]
    },
    {
      path: "event-forms",
      name: "admin-event-forms",
      redirect: { name: 'admin-event-forms-awaiting-review' },
      meta: {
        title: 'Event Forms',
        layout: AdminLayout,
        permissions: [PERMISSIONS.admin.eventForms.access],
        },
      children: [
        {
          path: "awaiting-review",
          name: "admin-event-forms-awaiting-review",
          component: () => import("./views/admin/event-forms/Listing.vue"),
          meta: { title: 'Event Forms', layout: AdminLayout },
          props: {
            state: 'cs_approval_pending',
            title: 'Event Forms - Awaiting Review'
          }
        },
        {
          path: "conditionally-approved",
          name: "admin-event-forms-conditionally-approved",
          component: () => import("./views/admin/event-forms/Listing.vue"),
          meta: { title: 'Event Forms', layout: AdminLayout },
          props: {
            state: 'conditionally_approved',
            title: 'Event Forms - Conditionally Approved'
          }
        },
        {
          path: "approved",
          name: "admin-event-forms-approved",
          component: () => import("./views/admin/event-forms/Listing.vue"),
          meta: { title: 'Event Forms', layout: AdminLayout },
          props: {
            state: 'approved',
            title: 'Event Forms - Approved'
          }
        },
        {
          path: "rejected",
          name: "admin-event-forms-rejected",
          component: () => import("./views/admin/event-forms/Listing.vue"),
          meta: { title: 'Event Forms', layout: AdminLayout },
          props: {
            state: 'rejected',
            title: 'Event Forms - Rejected'
          }
        },
        {
          path: "changes-requested",
          name: "admin-event-forms-changes-requested",
          component: () => import("./views/admin/event-forms/Listing.vue"),
          meta: { title: 'Event Forms', layout: AdminLayout },
          props: {
            state: 'changes_requested',
            title: 'Event Forms - Changes Requested'
          }
        },
        {
          path: "archived",
          name: "admin-event-forms-archived",
          component: () => import("./views/admin/event-forms/Listing.vue"),
          meta: {
            title: 'Event Forms',
            layout: AdminLayout,
            permissions: [PERMISSIONS.admin.eventForms.viewArchived]
          },
          props: {
            state: 'archived',
            title: 'Event Forms - Archived'
          }
        },
      ]
    },
    {
      path: "event-forms/:id",
      name: "admin-event-form-show",
      component: () => import("./views/admin/event-forms/Show.vue"),
      meta: { title: 'Event Form', layout: AdminLayout, permissions: [PERMISSIONS.admin.eventForms.access] }
    },
    {
      path: "event-forms/:id/edit",
      name: "admin-event-form-edit",
      component: () => import("./views/admin/event-forms/Edit.vue"),
      meta: { title: 'Edit Event Form', layout: AdminLayout, permissions: [PERMISSIONS.admin.eventForms.access] }
    },
    {
      path: "event-forms/:eventFormId/sub-requests/:id",
      name: "admin-event-form-sub-request-show",
      component: () => import("./views/admin/event-forms/sub-requests/Show.vue"),
      meta: { title: 'Sub Request', layout: AdminLayout, permissions: [PERMISSIONS.admin.eventForms.access] }
    },
    {
      path: "club-applications/:id",
      name: "admin-club-application-show",
      component: () => import("@/views/admin/club-applications/Show.vue"),
      meta: { title: 'Club Applications', layout: AdminLayout, permissions: [PERMISSIONS.admin.clubApplications.access] }
    },
    {
      path: 'groups',
      name: 'admin-groups',
      meta: { permissions: [PERMISSIONS.admin.groups.view] },
      children: [
        {
          path: "",
          name: "admin-groups-listing",
          component: () => import("./views/admin/groups/Listing.vue"),
          meta: { title: 'Groups', layout: AdminLayout, permissions: [PERMISSIONS.admin.groups.view] }
        },
        {
          path: ":id",
          name: "admin-groups-view",
          meta: { permissions: [PERMISSIONS.admin.groups.view] },
          children: [
            {
              path: "",
              name: "admin-groups-show",
              component: () => import("./views/admin/groups/Show.vue"),
              meta: { title: 'View Group', layout: AdminLayout, permissions: [PERMISSIONS.admin.groups.view] },
              redirect: { name: 'admin-groups-show-members'},
              children: [
                {
                  path: "members",
                  name: "admin-groups-show-members",
                  components: { groupDetail: () => import("./views/admin/groups/components/MemberList.vue") },
                  meta: { title: 'View Group - Members', layout: AdminLayout, permissions: [PERMISSIONS.admin.groups.view] }
                },
                {
                  path: "permissions",
                  name: "admin-groups-show-permissions",
                  components: { groupDetail: () => import("./views/admin/groups/components/Permissions.vue") },
                  meta: { title: 'View Group - Permissions', layout: AdminLayout, permissions: [PERMISSIONS.admin.groups.view] }
                }
              ]
            },
          ]
        },
      ]
    },
    {
      path: 'users',
      children: [
        {
          path: "",
          name: "admin-users-listing",
          component: () => import("./views/admin/users/Listing.vue"),
          meta: { 
            title: 'Users', 
            layout: AdminLayout, 
            permissions: [PERMISSIONS.admin.users.viewUsers]
          }
        },
        {
          path: ":id",
          name: "admin-users-view",
          meta: { permissions: [PERMISSIONS.admin.users.viewUsers] },
          children: [
            {
              path: "",
              name: "admin-users-show",
              component: () => import("./views/admin/users/Show.vue"),
              meta: { title: 'View User', layout: AdminLayout, permissions: [PERMISSIONS.admin.users.viewUsers] },
              redirect: { name: 'admin-users-show-overview' },
              children: [
                {
                  path: "overview",
                  name: "admin-users-show-overview",
                  components: { userDetail: () => import("./views/admin/users/components/Overview.vue") },
                  meta: { title: 'View User - Overview', layout: AdminLayout, permissions: [PERMISSIONS.admin.users.viewUsers] }
                },
                {
                  path: "groups-and-permissions",
                  name: "admin-users-show-groups-permissions",
                  components: { userDetail: () => import("./views/admin/users/components/GroupsAndPermissions.vue") },
                  meta: { title: 'View User - Groups & Permissions', layout: AdminLayout, permissions: [PERMISSIONS.admin.users.viewUsers] }
                },
                {
                  path: "membership-history",
                  components: { userDetail: () => import("./views/admin/users/components/MembershipHistory/MembershipHistory.vue") },
                  meta: { title: 'View User - Membership History', layout: AdminLayout, permissions: [PERMISSIONS.admin.users.viewUsers] },
                  children: [
                    {
                      path: "",
                      name: "admin-users-show-membership-history-select",
                      component: () => import("./views/admin/users/components/MembershipHistory/SelectTerm.vue")
                    },
                    {
                      path: ":termId",
                      name: "admin-users-show-membership-history-term",
                      component: () => import("./views/admin/users/components/MembershipHistory/ForTerm.vue")
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          path: "import",
          name: "admin-users-import",
          component: () => import("./views/admin/users/Import.vue"),
          meta: {
            title: 'Import Users',
            layout: AdminLayout,
            permissions: [PERMISSIONS.admin.users.importUsers]
          }
        },
        {
          path: "imports/:id/results",
          name: "admin-user-csv-import-results",
          component: () => import("./views/admin/users/ImportResults.vue"),
          props: true,
          meta: {
            title: 'Import Results',
            layout: AdminLayout,
            permissions: [PERMISSIONS.admin.users.importUsers]
          }
        }
      ]
    },
    {
      path: "forms",
      name: "admin-forms-listing",
      component: () => import("./views/admin/forms/Listing.vue"),
      meta: { title: 'Form', layout: AdminLayout, permissions: [PERMISSIONS.admin.forms.access] }
    },
    {
      path: "forms/:id",
      name: "admin-form",
      component: () => import("./views/admin/forms/ShowLayout.vue"),
      meta: { title: 'Form', layout: AdminLayout, permissions: [PERMISSIONS.admin.forms.access] },
      children: [
        {
          path: "",
          name: "admin-form-root",
          component: () => import("./views/admin/forms/Show.vue"),
          meta: { title: 'Form', layout: AdminLayout, permissions: [PERMISSIONS.admin.forms.access] },
        },
        {
          path: "availability",
          name: "admin-form-availability",
          component: () => import("./components/admin/forms/availability/FormAvailabilityEditor.vue"),
          meta: { title: 'Form Availability', layout: AdminLayout, permissions: [PERMISSIONS.admin.forms.manageAvailability] },
        },
        {
          path: "manage-permissions",
          name: "admin-form-manage-permissions",
          component: () => import("./views/admin/forms/ManagePermissions.vue"),
          meta: { title: 'Form Permissions', layout: AdminLayout, permissions: [PERMISSIONS.admin.forms.managePermissions] },
        }
      ]
    },
    {
      path: "settings",
      name: "admin-settings",
      meta: { 
        permissions: [PERMISSIONS.admin.settings.manage]
      },
      children: [
        {
          path: "",
          name: "admin-settings-edit",
          component: () => import("./views/admin/settings/Edit.vue"),
          meta: { 
            title: 'Settings', 
            layout: AdminLayout 
          }
        }
      ]
    },
    {
      path: "risk-management",
      name: "admin-risk-management",
      meta: {
        permissions: [PERMISSIONS.admin.riskManagement.access]
      },
      redirect: { name: 'admin-risk-management-dashboard' },
      children: [
        {
          path: "",
          name: "admin-risk-management-dashboard",
          component: () => import("./views/admin/risk-management/Dashboard.vue"),
          meta: { title: 'Risk Management', layout: AdminLayout }
        },
        {
          path: "risk-conditions",
          name: "admin-event-risk-conditions",
          component: () => import("./views/admin/events/ManageRiskConditions.vue"),
          meta: { title: 'Manage Risk Conditions', layout: AdminLayout, permissions: [PERMISSIONS.admin.riskScores.view] }
        }
      ]
    },
    {
      path: "event-types",
      name: "admin-event-types",
      meta: { permissions: [PERMISSIONS.admin.eventTypes.view] },
      redirect: { name: 'admin-event-types-listing-active' },
      children: [
        {
          path: "active",
          name: "admin-event-types-listing-active",
          component: () => import("./views/admin/event-types/ActiveListing.vue"),
          meta: { title: 'Event Types', layout: AdminLayout }
        },
        {
          path: "deleted",
          name: "admin-event-types-listing-deleted",
          component: () => import("./views/admin/event-types/DeletedListing.vue"),
          meta: { title: 'Event Types', layout: AdminLayout }
        }
      ]
    },
    {
      path: "risk-levels",
      name: "admin-risk-levels",
      meta: { },
      children: [
        {
          path: "",
          name: "admin-risk-levels-listing",
          component: () => import("./views/admin/risk-levels/Listing.vue"),
          meta: { title: 'Risk Levels', layout: AdminLayout, permissions: [PERMISSIONS.admin.riskLevels.view] }
        }
      ]
    },
    {
      path: "av-categories",
      name: "admin-av-categories",
      meta: { permissions: [PERMISSIONS.admin.avEquipmentCategories.view] },
      children: [
        {
          path: "active",
          name: "admin-av-categories-listing-active",
          component: () => import("./views/admin/av-categories/CategoryListing.vue"),
          props: { status: 'active' },
          meta: { title: 'AV Categories', layout: AdminLayout, permissions: [PERMISSIONS.admin.avEquipmentCategories.view] }
        },
        {
          path: "inactive",
          name: "admin-av-categories-listing-inactive",
          component: () => import("./views/admin/av-categories/CategoryListing.vue"),
          props: { status: 'inactive' },
          meta: { title: 'AV Categories', layout: AdminLayout, permissions: [PERMISSIONS.admin.avEquipmentCategories.view] }
        }
      ]
    },
    {
      path: "term-acknowledgement-form-listings",
      name: "admin-term-acknowledgement-form",
      meta: {
        permissions: [PERMISSIONS.admin.termAcknowledgementForms.view, PERMISSIONS.admin.termAcknowledgementForms.manage],
        permissionMode: 'any'
      },
      children: [
        {
          path: "",
          name: "admin-term-acknowledgement-form-listing",
          component: () => import("./views/admin/term-acknowledgement-forms/Listing.vue"),
          meta: { title: 'Term Acknowledgement Forms', layout: AdminLayout, permissions: [PERMISSIONS.admin.termAcknowledgementForms.view, PERMISSIONS.admin.termAcknowledgementForms.manage], permissionMode: 'any' }
        },
        {
          path: ":id",
          name: "admin-term-acknowledgement-form-show",
          component: () => import("./views/admin/term-acknowledgement-forms/Show.vue"),
          meta: { title: 'Term Acknowledgement Forms', layout: AdminLayout, breadcrumb: { label: 'View', to: 'admin-term-acknowledgement-form-show' }, permissions: [PERMISSIONS.admin.termAcknowledgementForms.view, PERMISSIONS.admin.termAcknowledgementForms.manage], permissionMode: 'any' }
        }
      ]
    },
    {
      path: "reports",
      name: "admin-reports",
      meta: { },
      children: [
        { // /admin/reports/clubs-emails
          path: "clubs-emails",
          name: "admin-clubs-emails-listing",
          component: () => import("./views/admin/reports/clubs-email/Listing.vue"),
          meta: { title: 'Reports', layout: AdminLayout, permissions: [] } //PERMISSIONS.admin.clubEmails.view] }
        },
        { // /admin/reports/clubs-emails/provisioning
          path: "clubs-emails/provisioning",
          name: "admin-clubs-emails-listing-provisioning",
          component: () => import("./views/admin/reports/clubs-email/Listing.vue"),
          meta: { title: 'Reports', layout: AdminLayout, permissions: [] } //PERMISSIONS.admin.clubEmails.view] }
        },
        {
          path: "club-codes",
          name: "admin-club-codes-listing",
          component: () => import("./views/admin/reports/club-codes/Listing.vue"),
          meta: { title: 'Reports', layout: AdminLayout, permissions: [PERMISSIONS.admin.clubCodeReports.access] }
        },
        {
          path: "inactive-clubs",
          name: "admin-inactive-clubs-listing",
          component: () => import("./views/admin/reports/inactive-clubs/Listing.vue"),
          meta: { title: 'Reports', layout: AdminLayout, permissions: [PERMISSIONS.admin.clubsInactiveReports.access] }
        },
        {
          path: "clubs-without-codes",
          name: "admin-clubs-without-codes-listing",
          component: () => import("./views/admin/reports/club-codes/ClubsWithoutCodes.vue"),
          meta: { title: 'Reports', layout: AdminLayout, permissions: [PERMISSIONS.admin.clubCodeReports.access] }
        }
      ]
    },
    {
      path: "clubs",
      name: "admin-clubs",
      meta: {
        permissions: [
          PERMISSIONS.admin.clubs.view
        ]  
      },
      children: [
        {
          path: "all-clubs",
          name: "admin-clubs-listing-all",
          component: () => import("./views/admin/clubs/AllListing.vue"),
          meta: { title: 'Clubs', layout: AdminLayout, permissions: [PERMISSIONS.admin.clubs.view] }
        },
        {
          path: "active-clubs",
          name: "admin-clubs-listing-active",
          component: () => import("./views/admin/clubs/ActiveListing.vue"),
          meta: { title: 'Clubs', layout: AdminLayout, permissions: [PERMISSIONS.admin.clubs.view] }
        },
        {
          path: "inactive-clubs",
          name: "admin-clubs-listing-inactive",
          component: () => import("./views/admin/clubs/InactiveListing.vue"),
          meta: { title: 'Clubs', layout: AdminLayout, permissions: [PERMISSIONS.admin.clubs.view] }
        },
        {
          path: "purged-clubs",
          name: "admin-clubs-listing-purged",
          component: () => import("./views/admin/clubs/PurgedListing.vue"),
          meta: { title: 'Clubs', layout: AdminLayout, permissions: [PERMISSIONS.admin.clubs.viewPurged] }
        },
        {
          path: ":id",
          name: "admin-clubs-view",
          meta: { },
          children: [
          {
            path: "",
            name: "admin-clubs-show",
            component: () => import("./views/admin/clubs/Show.vue"),
            meta: { title: 'View Club', layout: AdminLayout },
            redirect: { name: 'admin-clubs-show-overview' },
            children: [
              {
                path: 'overview',
                name: 'admin-clubs-show-overview',
                components: { adminDetail: () => import("./views/admin/clubs/components/Overview.vue") },
                meta: { title: 'View Club - Overview', layout: AdminLayout }
              },
              {
                path: 'associated-clubs',
                name: 'admin-clubs-show-associated',
                components: { adminDetail: () => import("./views/admin/clubs/components/AssociatedClubs.vue") },
                meta: { title: 'View Club - Associated Clubs', layout: AdminLayout, permissions: [PERMISSIONS.admin.associatedClubs.view] }
              },
              {
                path: 'transactions',
                name: 'admin-clubs-show-transactions',
                components: { adminDetail: () => import("./views/admin/clubs/components/Transactions.vue") },
                meta: { 
                  title: 'View Club - Transactions', 
                  layout: AdminLayout, 
                  permissions: [PERMISSIONS.admin.finances.view] 
                }
              },
              {
                path: 'members',
                name: 'admin-clubs-show-members',
                components: { adminDetail: () => import("./views/admin/clubs/components/Members.vue") },
                meta: { title: 'View Club - Members', layout: AdminLayout, permissions: [PERMISSIONS.admin.clubMembers.view] }
              },
              {
                path: 'past-members',
                components: { adminDetail: () => import("./views/admin/clubs/components/PastMembersLayout.vue") },
                meta: { title: 'View Club - Past Members', layout: AdminLayout, permissions: [PERMISSIONS.admin.clubMembers.view] },
                children: [
                  {
                    name: 'admin-clubs-show-past-members',
                    path: '',
                    component: () => import("./views/admin/clubs/components/PastMembers/TermSelection.vue"),
                    meta: { title: 'View Club - Past Members', layout: AdminLayout },
                  },
                  {
                    path: ':termId',
                    name: 'admin-clubs-show-past-members-term',
                    component: () => import("./views/admin/clubs/components/PastMembers/PastMembers.vue"),
                    meta: { title: 'View Club - Past Members', layout: AdminLayout },
                  }
                ]
              },
              {
                path: 'term-history',
                name: 'admin-clubs-show-term-history',
                components: { adminDetail: () => import("./views/admin/clubs/components/TermHistory.vue") },
                meta: {
                  title: 'View Club - Term History',
                  layout: AdminLayout,
                  // Backend: Admin::TermAcknowledgementFormPolicy#index? grants via view OR manage.
                  permissions: [
                    PERMISSIONS.admin.termAcknowledgementForms.view,
                    PERMISSIONS.admin.termAcknowledgementForms.manage
                  ],
                  permissionMode: 'any'
                }
              }
            ]
          },
          {
              path: "constitution",
              name: "admin-club-profile-constitution",
              component: () => import("./views/club/ClubConstitution.vue"),
              meta: { title: 'Edit Club Profile Update', layout: AdminLayout },
              props: { showBackButton: false }
            },
          {
            path: "term-acknowledgement-forms/new",
            name: "admin-clubs-term-acknowledgement-form-new",
            component: () => import("./views/admin/clubs/term-acknowledgement-form/New.vue"),
            meta: {
              title: 'Enter Term Acknowledgement Form',
              layout: AdminLayout,
              permissions: [PERMISSIONS.admin.termAcknowledgementForms.manage]
            }
          },
          {
            path: "edit",
            name: "admin-club-profile-edit",
            component: () => import("./views/admin/clubs/Edit.vue"),
            meta: {
              title: 'Edit Club Profile Update',
              layout: AdminLayout,
              // 'any': the rename entry point lives on this page (Information tab),
              // so an admin holding only club.rename must be able to reach it —
              // each section inside is independently <Can>-gated.
              permissions: [PERMISSIONS.admin.clubs.updateProfile, PERMISSIONS.admin.clubs.rename],
              permissionMode: 'any',
            },
            redirect: { name: 'admin-club-profile-edit-information' },
            children: [
              {
                path: 'information',
                name: 'admin-club-profile-edit-information',
                component: () => import('./views/admin/clubs/edit/Information.vue'),
                meta: { title: 'Edit Club Profile - Information', layout: AdminLayout },
              },
              {
                path: 'socials',
                name: 'admin-club-profile-edit-socials',
                component: () => import('./views/admin/clubs/edit/Socials.vue'),
                meta: { title: 'Edit Club Profile - Websites & Socials', layout: AdminLayout },
              },
              {
                path: 'links',
                name: 'admin-club-profile-edit-links',
                component: () => import('./views/admin/clubs/edit/Links.vue'),
                meta: { title: 'Edit Club Profile - Links', layout: AdminLayout },
              },
              {
                path: 'gallery',
                name: 'admin-club-profile-edit-gallery',
                component: () => import('./views/admin/clubs/edit/Gallery.vue'),
                meta: { title: 'Edit Club Profile - Gallery', layout: AdminLayout },
              },
            ],
          },
          ]
        },
        {
          path: ":id/emails",
          name: "admin-clubs-emails",
          component: () => import("./views/admin/reports/clubs-email/Listing.vue"),
          meta: { title: 'Clubs Emails', layout: AdminLayout }
        },
        {
          path: ":id/emails/provisioning",
          name: "admin-clubs-emails-provisioning",
          component: () => import("./views/admin/reports/clubs-email/Listing.vue"),
          meta: { title: 'Clubs Emails', layout: AdminLayout }
        },
      ]
    },
    {
      path: 'club-profile-updates',
      name: 'admin-club-profile-updates',
      // Section access is gated by `club_profile_request.access`; per-record
      // approve/reject actions are further gated via permissions_for_user on the API response.
      meta: { permissions: [PERMISSIONS.admin.clubProfileRequests.access] },
      children: [
        {
          path: "pending",
          name: "admin-club-profile-updates-listing-pending",
          component: () => import("./views/admin/clubs-update-form/PendingListing.vue"),
          meta: { title: 'Clubs', layout: AdminLayout }
        },
        {
          path: "rejected",
          name: "admin-club-profile-updates-listing-rejected",
          component: () => import("./views/admin/clubs-update-form/RejectedListing.vue"),
          meta: { title: 'Clubs', layout: AdminLayout }
        },
        {
          path: "approved",
          name: "admin-club-profile-updates-listing-completed",
          component: () => import("./views/admin/clubs-update-form/ApprovedListing.vue"),
          meta: { title: 'Clubs', layout: AdminLayout }
        },
        {
          path: ":id",
          name: "admin-club-profile-update-show",
          component: () => import("./views/admin/clubs-update-form/Show.vue"),
          meta: { title: 'Club Profile Update', layout: AdminLayout },
        },
      ]
    },
    {
      path: 'club-reimbursement-requests',
      name: 'admin-club-reimbursement-requests',
      meta: { permissions: [PERMISSIONS.admin.reimbursementRequests.access] },
      children: [
        {
          path: "pending",
          name: "admin-club-reimbursement-requests-listing-pending",
          component: () => import("./views/admin/clubs-reimbursement-requests/Listing.vue"),
          meta: { title: 'Clubs', layout: AdminLayout },
        },
        {
          path: "on-hold",
          name: "admin-club-reimbursement-requests-listing-on-hold",
          component: () => import("./views/admin/clubs-reimbursement-requests/Listing.vue"),
          meta: { title: 'Clubs', layout: AdminLayout },
        },
        {
          path: "not-on-hold",
          name: "admin-club-reimbursement-requests-listing-not-on-hold",
          component: () => import("./views/admin/clubs-reimbursement-requests/Listing.vue"),
          meta: { title: 'Clubs', layout: AdminLayout },
        },
        {
          path: "approved-by-me",
          name: "admin-club-reimbursement-requests-listing-approved-by-me",
          component: () => import("./views/admin/clubs-reimbursement-requests/Listing.vue"),
          meta: { title: 'Clubs', layout: AdminLayout },
        },
        {
          path: ":id",
          name: "admin-club-reimbursement-requests-show",
          component: () => import("./views/admin/clubs-reimbursement-requests/Show.vue"),
          meta: { title: 'Clubs', layout: AdminLayout },
        },
        {
          path: ":id/edit",
          name: "admin-club-reimbursement-requests-edit",
          component: () => import("./views/admin/clubs-reimbursement-requests/Edit.vue"),
          meta: { title: 'Clubs', layout: AdminLayout },
        },
        {
          path: "batch/:batch_id",
          name: "admin-club-reimbursement-requests-batch",
          component: () => import("./views/admin/clubs-reimbursement-requests/BatchProcessing.vue"),
          meta: { title: 'Batch Processing', layout: AdminLayout, permissions: [PERMISSIONS.admin.reimbursementRequests.access, PERMISSIONS.admin.reimbursementRequests.viewBatches] },
        },
        {
          path: "batches",
          name: "admin-club-reimbursement-requests-batches-listing",
          component: () => import("./views/admin/clubs-reimbursement-requests/BatchesListing.vue"),
          meta: {
            title: 'Reimbursement Request Batches',
            layout: AdminLayout,
            permissions: [PERMISSIONS.admin.reimbursementRequests.access, PERMISSIONS.admin.reimbursementRequests.viewBatches]
          },
        }
      ]
    },
    {
      path: 'bookable-locations',
      name: 'admin-bookable-locations',
      meta: { permissions: [PERMISSIONS.admin.locations.manage] },
      children: [
        {
          path: 'all',
          name: 'admin-bookable-locations-listing-all',
          component: () => import('./views/admin/bookable-locations/Listing.vue'),
          meta: { title: 'Bookable Locations', layout: AdminLayout, permissions: [PERMISSIONS.admin.locations.manage] },
          props: { enabledFilter: null }
        },
        {
          path: 'enabled',
          name: 'admin-bookable-locations-listing-enabled',
          component: () => import('./views/admin/bookable-locations/Listing.vue'),
          meta: { title: 'Bookable Locations', layout: AdminLayout, permissions: [PERMISSIONS.admin.locations.manage] },
          props: { enabledFilter: true }
        },
        {
          path: 'disabled',
          name: 'admin-bookable-locations-listing-disabled',
          component: () => import('./views/admin/bookable-locations/Listing.vue'),
          meta: { title: 'Bookable Locations', layout: AdminLayout, permissions: [PERMISSIONS.admin.locations.manage] },
          props: { enabledFilter: false }
        },
        {
          path: 'import',
          name: 'admin-bookable-locations-import',
          component: () => import('./views/admin/locations/Import.vue'),
          meta: { title: 'Import Locations', layout: AdminLayout, permissions: [PERMISSIONS.admin.locations.manage] }
        },
      ]
    },
    {
      path: 'resources',
      name: 'admin-resources',
      meta: { 
        permissions: [PERMISSIONS.admin.resources.access]
      },
      children: [
        {
          path: "listing",
          name: "admin-resources-listing",
          component: () => import("./views/admin/resources/Listing.vue"),
          meta: { title: 'Resources', layout: AdminLayout }
        },
      ]
    },
    {
      path: "email-logs",
      name: "admin-email-logs",
      meta: {
        permissions: [PERMISSIONS.admin.emailLogs.access]
      },
      children: [
        {
          path: "",
          name: "admin-email-logs-listing",
          component: () => import("./views/admin/email-logs/Listing.vue"),
          meta: { title: 'Email Log', layout: AdminLayout }
        }
      ]
    },
    {
      path: "system-monitoring",
      name: "admin-system-monitoring",
      component: () => import("./views/admin/system-monitoring/Dashboard.vue"),
      meta: {
        title: 'System Monitoring',
        layout: AdminLayout,
        permissions: [PERMISSIONS.admin.systemMonitoring.show]
      }
    }
  ]
}
